import { forwardRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { Moon, Utensils, Home, Lightbulb, ChefHat, Music, Mail } from "lucide-react";
import AtariController from "@/components/icons/AtariController";
import { useLanguage } from "@/contexts/LanguageContext";
import { useTranslatedTexts } from "@/hooks/useTranslatedTexts";

const navItems = [
  { path: "/", labelKey: "home", icon: Home },
  { path: "/baby-sleep", labelKey: "sleep", icon: Moon },
  { path: "/baby-feeding", labelKey: "feeding", icon: Utensils },
  { path: "/baby-tips", labelKey: "tips", icon: Lightbulb },
  { path: "/baby-recipes", labelKey: "recipes", icon: ChefHat },
  { path: "/baby-lullabies", labelKey: "lullabies", icon: Music },
  { path: "/baby-games", labelKey: "games", icon: AtariController },
  { path: "/contact", labelKey: "contact", icon: Mail },
];

const BottomNav = forwardRef<HTMLElement>((_, ref) => {
  const location = useLocation();
  const { t } = useLanguage();
  const { translated: tContact } = useTranslatedTexts(["Contact"], "nav-contact");

  const getLabel = (labelKey: string) => labelKey === "contact" ? tContact[0] : t(labelKey);

  return (
    <nav ref={ref} className="fixed bottom-0 left-0 right-0 z-50 border-t border-border bg-card/95 backdrop-blur-md md:bottom-4 md:left-1/2 md:-translate-x-1/2 md:right-auto md:w-auto md:rounded-2xl md:border md:shadow-lg md:max-w-3xl">
      <div className="mx-auto flex max-w-lg items-center overflow-x-auto py-2 scrollbar-hide md:max-w-none md:px-2">
        {navItems.map(({ path, labelKey, icon: Icon }) => {
          const isActive = location.pathname === path;
          return (
            <Link
              key={path}
              to={path}
              className={`flex flex-shrink-0 flex-col items-center gap-0.5 px-3 py-1.5 text-xs font-semibold transition-colors ${
                isActive ? "text-primary" : "text-muted-foreground hover:text-foreground"
              }`}
            >
              <Icon className={`h-5 w-5 ${isActive ? "text-primary" : ""}`} />
              {getLabel(labelKey)}
            </Link>
          );
        })}
      </div>
    </nav>
  );
});

BottomNav.displayName = "BottomNav";

export default BottomNav;
